var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"date-range-container",attrs:{"align-center":"","justify-center":"","column":""}},[_vm._v(" "+_vm._s(_vm.calculatedText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }